import "intersection-observer";

import React, { useEffect, useRef, useState } from "react";

import css from "./video.module.scss";
import { fireEvent } from "../utils/tracking";
import { isSafari } from "../utils/browser";
import playImg from "../../../static/images/play-btn.svg";

const noop = () => {};

function useOnScreen(ref, rootMargin = "0px") {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, rootMargin]);
  return isIntersecting;
}
export default function Video({
  glance,
  onPlay = noop,
  onPause = noop,
  index
}) {
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  const [show, SetShow] = useState(false);
  const [btnClicked, setBtnClicked] = useState(false);

  useEffect(
    function() {
      if (btnClicked && onScreen) {
        SetShow(true);
      } else if (!onScreen) {
        SetShow(false);
        setBtnClicked(false);
      }
    },
    [onScreen, btnClicked]
  );
  function clickHandler() {
    setBtnClicked(true);
    fireEvent("Glance", "Play Video", index);
  }
  const video = glance.peek.nativeVideoPeek.videoUrl;
  return video ? (
    <div className={css["resp-container"]} ref={ref}>
      {show ? (
        isSafari() ? (
          <video
            width="100%"
            controls
            muted={false}
            autoPlay
            playsInline
            className={css["horizontal-video"]}
            onPlay={onPlay}
            onPause={onPause}
          >
            <source src={video} />
          </video>
        ) : (
          <video
            width="100%"
            controls
            autoPlay
            className={css["horizontal-video"]}
            onPlay={onPlay}
            onPause={onPause}
          >
            <source src={video} />
          </video>
        )
      ) : (
        <div className={css["video"]}>
          <div className={css["videoBtn"]} onClick={clickHandler}>
            <img
              src={playImg}
              alt="video thumbnail"
              className={css["width100"]}
            />
          </div>
        </div>
      )}
    </div>
  ) : null;
}
